export const ADDRESS_WITHOUT_NUMBER = 'S/N'

export function normalizeAddressNumber(value?: string | null): string {
  const normalized = `${value ?? ''}`.trim()
  return normalized.toUpperCase() === ADDRESS_WITHOUT_NUMBER
    ? ADDRESS_WITHOUT_NUMBER
    : normalized
}

export function isAddressWithoutNumber(value?: string | null): boolean {
  return normalizeAddressNumber(value) === ADDRESS_WITHOUT_NUMBER
}
